import { PropertyDetail } from '../types'

/** TYPES **/
export const clientPropertiesTypes = {
  FETCH_CLIENT_PROPERTIES: 'FETCH_CLIENT_PROPERTIES',
  SET_CLIENT_PROPERTIES: 'SET_CLIENT_PROPERTIES'
}

/** ACTIONS **/
export interface FetchClientPropertiesAction {
  type: typeof clientPropertiesTypes.FETCH_CLIENT_PROPERTIES
  customerId: string
  callback?: (succ: boolean) => void
}

export interface SetClientPropertiesAction {
  type: typeof clientPropertiesTypes.SET_CLIENT_PROPERTIES
  payload: PropertyDetail[] | null
}

export type ClientPropertiesActions =
  | FetchClientPropertiesAction
  | SetClientPropertiesAction

/** REDUCER **/
export type ClientPropertiesType = PropertyDetail[] | null

